import React, { useMemo } from 'react'
import moment from 'moment'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { getAbbreviatedCoachName } from '@src/utils/coach'
import { VIDEO_SUGGESTED_CALL_CARD_TIME_FORMAT } from '@src/config/momentFormat'
import { Icon, Text } from '@src/components/base'

interface AppointmentBodyProps {
  coachName?: string | null
  meetingAt: string
  duration: string
}

export const AppointmentBody = ({ coachName, meetingAt, duration }: AppointmentBodyProps) => {
  const styles = useStyleSheet(themedStyles)
  const abbreviatedCoachName = useMemo(() => getAbbreviatedCoachName(coachName), [coachName])
  const meetingTime = moment(meetingAt).format(VIDEO_SUGGESTED_CALL_CARD_TIME_FORMAT)

  return (
    <View style={styles.body}>
      {abbreviatedCoachName && (
        <Text type="regular" lineSpacing="none" style={styles.coachName}>
          {abbreviatedCoachName}
        </Text>
      )}
      <View style={styles.details}>
        <View style={styles.detailItem}>
          <Icon name="clock" size={16} style={styles.detailItemIcon} />
          <Text type="regular" lineSpacing="none">
            {meetingTime}
          </Text>
        </View>
        <View style={styles.detailItem}>
          <Icon name="hourglass-simple-medium" size={16} style={styles.detailItemIcon} />
          <Text type="regular" lineSpacing="none">
            {duration} min
          </Text>
        </View>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  body: {
    gap: 8,
  },
  coachName: {
    color: 'theme.text.secondary',
  },
  details: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
  },
  detailItem: {
    flexDirection: 'row',
    gap: 6,
    alignItems: 'center',
  },
  detailItemIcon: {
    color: 'theme.text.secondary',
  },
})
